import React from 'react'; //eslint-disable-line
//import { useTranslation } from 'react-i18next';
import TagItem from './TagItem';
// import goTrackerConfig from 'goTrackerConfig';

const Tags = props => {
  //const { t } = useTranslation();
  //TODO - Add flag when there are multiple tags
  if (!props.trip.coachCount) return null;

  /*const coachCountTag = `${props.trip.coachCount} ${t('tags.coach')}`;*/
  const shouldBlink = props.trip.coachCount === props.trip.scheduledCoachCount ? false : true;

  return (
    <div className='tags-container'>
      <TagItem value={`${props.trip.coachCount}`} blink={shouldBlink} />
    </div>
  );
};


export default Tags;
